import React from 'react';
import './Q3.scss';
import CalendarBullets from '../shared/CalendarBullets.jsx'
import BackNext from '../shared/BackNext.jsx'
import MainNav from '../shared/MainNav.jsx'
import BothCalendars from '../shared/BothCalendars.jsx'
import QuestionNav from '../shared/QuestionNav.jsx'
const figure = require('./Q3_figure.png')

const Q3 = ({ lexicon, studyId }) => {

  return (
    <div id="Q3">
      <div className="top">
        <div className="left">
          <div className="navs">
            <MainNav current="/qanda"  studyId={studyId}/>
            <QuestionNav lexicon={lexicon} current="q3" studyId={studyId} />
          </div>
          <div className="headers">
            <h1>{lexicon.get("Q3.title")}</h1>
          </div>
        </div>
        <div className="right desktop">
          <img src={figure} alt="Pregnant pic"/>
        </div>
      </div>
      <div className="calendars">
        <div className="mobile">
          <div className="calendar-container">
            <CalendarBullets 
              title={lexicon.get("Q3.same")}
              bullets={[lexicon.get("Q3.sometimes"),
                        lexicon.get("Q3.medications"),
                        lexicon.get("Q3.your-water")
                      ]} 
              calendarType="both"
            />
          </div>
          <BackNext backPath="/q2" nextPath="/q4" studyId={studyId} />
        </div>
        <div className="desktop">
          <div className="bottom">
            <div className="wait">
            </div>
            <div className="schedule">
            </div>
            <div className="content">
              <div className="row">
                <BothCalendars />
                <h3>{lexicon.get("Q3.same")}</h3>
              </div>
              <ul>
                <li>{lexicon.get("Q3.sometimes")}</li>
                <li>{lexicon.get("Q3.medications")}</li>
                <li>{lexicon.get("Q3.your-water")}</li>
              </ul>
              <div className="back-next-desktop">
                <BackNext backPath="/q2" nextPath="/q4" studyId={studyId} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Q3 ;
